import { composeModules } from 'holocron';
import { loadLanguagePack } from '@americanexpress/one-app-ducks';

export const getValueFromPropsOrRouteProps = (name, props, defaultValue) => {
  const { route = {} } = props;
  return props[name] || route[name] || defaultValue;
};

export const loadModuleData = async (props) => {
  const { ownProps } = props;
  const isHeaderDisabled = getValueFromPropsOrRouteProps('isHeaderDisabled', ownProps, false);
  const isFooterDisabled = getValueFromPropsOrRouteProps('isFooterDisabled', ownProps, false);
  const header = getValueFromPropsOrRouteProps('header', ownProps, 'axp-global-header');
  const footer = getValueFromPropsOrRouteProps('footer', ownProps, 'axp-footer');
  const siteAreaNavModule = getValueFromPropsOrRouteProps('siteAreaNavModuleName', ownProps);

  const modules = [];

  if (!isHeaderDisabled) {
    modules.push({ name: header });
  }

  if (!isFooterDisabled) {
    modules.push({ name: footer });
  }

  if (siteAreaNavModule) {
    modules.push({ name: siteAreaNavModule });
  }

  await props.store.dispatch(composeModules(modules));

  await props.store.dispatch(loadLanguagePack('axp-global-header', { locale: 'en-US', fallbackLocale: 'en-US' }));
  await props.store.dispatch(loadLanguagePack('axp-footer', { locale: 'en-US', fallbackLocale: 'en-US' }));

  await props.store.dispatch(loadLanguagePack('axp-global-header', { locale: 'en-GB', fallbackLocale: 'en-US' }));
  await props.store.dispatch(loadLanguagePack('axp-footer', { locale: 'en-GB', fallbackLocale: 'en-US' }));

  await props.store.dispatch(loadLanguagePack('axp-global-header', { locale: 'en-CA', fallbackLocale: 'en-US' }));
  await props.store.dispatch(loadLanguagePack('axp-footer', { locale: 'en-CA', fallbackLocale: 'en-US' }));

  await props.store.dispatch(loadLanguagePack('axp-global-header', { locale: 'es-ES', fallbackLocale: 'en-US' }));
  await props.store.dispatch(loadLanguagePack('axp-footer', { locale: 'es-ES', fallbackLocale: 'en-US' }));

  await props.store.dispatch(loadLanguagePack('axp-global-header', { locale: 'pt-BR', fallbackLocale: 'en-US' }));
  await props.store.dispatch(loadLanguagePack('axp-footer', { locale: 'pt-BR', fallbackLocale: 'en-US' }));

  await props.store.dispatch(loadLanguagePack('axp-global-header', { locale: 'it-IT', fallbackLocale: 'en-US' }));
  await props.store.dispatch(loadLanguagePack('axp-footer', { locale: 'it-IT', fallbackLocale: 'en-US' }));

  await props.store.dispatch(loadLanguagePack('axp-global-header', { locale: 'fr-FR', fallbackLocale: 'en-US' }));
  await props.store.dispatch(loadLanguagePack('axp-footer', { locale: 'fr-FR', fallbackLocale: 'en-US' }));

  await props.store.dispatch(loadLanguagePack('axp-global-header', { locale: 'fr-CA', fallbackLocale: 'en-US' }));
  await props.store.dispatch(loadLanguagePack('axp-footer', { locale: 'fr-CA', fallbackLocale: 'en-US' }));

  await props.store.dispatch(loadLanguagePack('axp-global-header', { locale: 'nl-NL', fallbackLocale: 'en-US' }));
  await props.store.dispatch(loadLanguagePack('axp-footer', { locale: 'nl-NL', fallbackLocale: 'en-US' }));

  await props.store.dispatch(loadLanguagePack('axp-global-header', { locale: 'sv-SE', fallbackLocale: 'en-US' }));
  await props.store.dispatch(loadLanguagePack('axp-footer', { locale: 'sv-SE', fallbackLocale: 'en-US' }));

  await props.store.dispatch(loadLanguagePack('axp-global-header', { locale: 'es-MX', fallbackLocale: 'en-US' }));
  await props.store.dispatch(loadLanguagePack('axp-footer', { locale: 'es-MX', fallbackLocale: 'en-US' }));

  await props.store.dispatch(loadLanguagePack('axp-global-header', { locale: 'en-AU', fallbackLocale: 'en-US' }));
  await props.store.dispatch(loadLanguagePack('axp-footer', { locale: 'en-AU', fallbackLocale: 'en-US' }));

  await props.store.dispatch(loadLanguagePack('axp-global-header', { locale: 'de-DE', fallbackLocale: 'en-US' }));
  await props.store.dispatch(loadLanguagePack('axp-footer', { locale: 'de-DE', fallbackLocale: 'en-US' }));
};
